import { CSSProperties } from 'react';
import { ISliderIndents } from '../../types';

interface IGetContainerStyleParams {
  indents: ISliderIndents;
  slideWidth?: number;
}

export function getContainerStyle(params: IGetContainerStyleParams): CSSProperties {
  const { indents, slideWidth } = params;
  const { top = 0, left = 0, bottom = 0 } = indents;

  return {
    scrollPaddingLeft: slideWidth ? `calc((100% - ${slideWidth}px) / 2)` : 0,
    // правый отступ схлопывается, поэтому добавляем правый отступ последнему слайду
    padding: `${top}px 0 ${bottom}px ${left}px`,
  };
}
